const cx = (...args) =>
  args
    .flatMap((arg) => {
      if (!arg) return [];
      if (typeof arg === 'string') return [arg];
      if (typeof arg === 'object') {
        return Object.keys(arg).filter((key) => arg[key]);
      }
      return [];
    })
    .join(' ');

export default cx;
